<template>
    <div class="custom-modal">
        <div @click="() => close()" class="custom-modal__background"></div>
        <div class="custom-modal__inner">

            <div class="custom-modal__header" ref="modalHeader">
                <slot name="modalHeader"/>
                <i @click="() => close()" class="fa fa-close"></i>
            </div>

            <div class="custom-modal__body" ref="modalBody" :style="modalBodyStyle">
                <slot name="modalBody"/>
            </div>

            <div class="custom-modal__footer" v-if="hasFooter">
                <slot name="modalFooter"/>
                <button class="uk-button" v-if="this.$props.printButton" @click="print">
                    <i class="uk-icon-print"></i>
                    Распечатать
                </button>
                <button v-if="this.$props.downloadButton" class="uk-button uk-button-primary" @click="getPdf">
                    <i class="uk-icon-file-pdf-o"></i>
                    Сохранить PDF
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import { htmlStringToPrint, translit, Base64 } from "@/helpers.ts"
import axios from 'axios'

export default {
    props: {
        close: Function,
        customInnerHeight: String,
        customInnerWidth: String,
        printButton: Boolean,
        downloadButton: {
            type: Boolean,
            default: true
        },
        printStyle: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: null
        }
    },
    methods: {
        print(){
            const headerText = this.$props.title || this.$slots.modalHeader.filter(e => e.children).map(e => e.children[0].text).filter(Boolean).join(' ')
            const imgHtmlCode = htmlStringToPrint(headerText, this.$refs.modalBody.outerHTML, `${this.$props.printStyle} .no_print, .tooltip-img {display: none !important;} .no_print-pre {white-space: pre-line;} .bold__date{font-weight: bold;`)

            const printWin = window.open();
            printWin.document.write(imgHtmlCode);
            printWin.document.close();
        },
        getPdf(){
            const headerText = this.$props.title || this.$slots.modalHeader.filter(e => e.children).map(e => e.children[0].text).filter(Boolean).join(' ')
            const imgHtmlCode = htmlStringToPrint(headerText, this.$refs.modalBody.outerHTML, `${this.$props.printStyle} #print-pdf-hint { display: none } .no_print {display: none !important} .no_print-pre {white-space: pre-line;} .bold__date{font-weight: bold;}`)
            const filename = `${translit(headerText)} ${window.company.ogrn}`

            this.$store.dispatch('v3/API', {
                method: 'save_file',
                reqOpts: { responseType: 'arraybuffer' },
                data: {
                    save_to_histore: false,
                    source: process.env.PRODUCT_CODE,
                    format: 'pdf',
                    landspace: false,
                    target: 'tile',
                    out_name: `${filename}.pdf`,
                    ogrn: window.company.ogrn,
                    html: Base64.encode(imgHtmlCode)
                }
            }).then(result => { window.downloadBinaryFile(result.data, `${filename}.pdf`) })
        }
    },
    computed: {
        hasFooter() {
            return this.$props.printButton || this.$props.downloadButton
        },
        modalBodyStyle() {
            if(this.hasFooter) {
                return { height: 'calc(80vh - 110px)' }
            } else {
                return { height: 'calc(80vh - 55px)' }
            }
        }
    }
}
</script>

<style scoped lang="sass">
$header-footer-size: 55px

.custom-modal__header
    border-bottom: 1px solid #ddd
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
    width: 100%
    font-family: Arial, Tahoma, sans-serif
    font-weight: 100
    font-size: 24px
    padding: 15px
    height: $header-footer-size
    padding-right: 40px
    i.fa.fa-close
        position: absolute
        right: 15px
        top: 15px
        cursor: pointer
        color: #444
        opacity: 0.3
        &:hover
            opacity: 0.7

.custom-modal__body
    white-space: normal
    overflow: auto
    font-size: 16px
    height: calc(80vh - #{$header-footer-size * 2})

.custom-modal__footer
    width: 100%
    height: 10vh
    padding: 10px
    border-top: 1px solid #ddd
    border-radius: 0 0 4px 4px
    bottom: 0
    text-align: right
</style>


<style>
.custom-modal {
    z-index: 300; 
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: left;
}

.custom-modal__inner {
    margin: 0 auto;
    border-radius: 5px;
    width: 80vw;
    height: 80vh;
    max-height: 80vh;
    background-color: #fafafa;
    top: 10vh;
    position: relative;
    overflow: hidden;
}

.custom-modal__background {
    background-color: rgba(0,0,0,.35);
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
}
</style>